<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="flex-fill d-flex flex-column">
    <div *ngIf="orderLineDetails" class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '800px' : '100%' }">
        <dx-data-grid
            #dataGrid
            [dataSource]="orderLineDetails"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChangedShared($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowUpdated)="onRowUpdated($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column width="60" [calculateSortValue]="sortByHotOrder" [allowSorting]="true" [sortIndex]="1" sortOrder="desc" cellTemplate="faTemplate"> </dxi-column>
            <dxi-column
                dataField="orderLine.order.invoiceNumber"
                caption="Order #"
                width="80"
                [cellTemplate]="!showAsDialog ? 'linkTemplate' : ''"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column dataField="orderLine.order.pONumber" caption="PO #" width="80" [cellTemplate]="!showAsDialog ? 'linkTemplate' : ''" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.order.shippingNote" caption="ShippingNotes" width="80" [allowEditing]="false"></dxi-column>
            <dxi-column
                dataField="orderLine.order.dealer.companyName"
                caption="Dealer"
                width="100"
                [allowEditing]="false"
                [cellTemplate]="!showAsDialog ? 'dealerTemplate' : ''"
                [sortIndex]="2"
                sortOrder="asc"
            ></dxi-column>
            <dxi-column dataField="orderLine.order.shipToCity" caption="City" width="100" [allowEditing]="false" cellTemplate="cityTemplate"></dxi-column>
            <dxi-column dataField="orderLine.order.shipToState" caption="State" width="45" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="false" width="65"></dxi-column>
            <dxi-column
                dataField="orderLine.partNumber"
                caption="Part #"
                width="125"
                [allowEditing]="false"
                [cellTemplate]="!showAsDialog ? 'partNumberTemplate' : ''"
            ></dxi-column>
            <dxi-column dataField="orderLine.description" caption="Description" width="125" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.part.description" caption="Production Description" width="125" [allowEditing]="false"></dxi-column>
            <dxi-column
                dataField="packingSlip.packingSlipNumber"
                caption="Slip #"
                width="125"
                [allowEditing]="false"
                [cellTemplate]="!showAsDialog ? 'editTemplate' : ''"
            ></dxi-column>
            <dxi-column
                dataField="invoiceNumberDisplay"
                caption="Invoice #"
                width="125"
                [allowEditing]="false"
                [cellTemplate]="!showAsDialog ? 'invoiceTemplate' : ''"
            ></dxi-column>
            <dxi-column dataField="orderLine.order.type.name" caption="Sales Order Type" width="80" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="noteHTML" caption="Notes" width="250" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
            <dxi-column dataField="status.name" caption="Status" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="vIN" caption="Vin #" width="100" [allowEditing]="true"></dxi-column>
            <dxi-column dataField="vinEndingDisplay" caption="Vin Last 7" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.order.createDate" caption="Order Date" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="deliveryOption.name" caption="Delivery" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="confirmationApproved" caption="Confirmation" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="dueDate" caption="Ship Due" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="buildDue" caption="Build Due" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="built" width="100" [allowEditing]="false" dataType="date" format="shortDateShortTime"></dxi-column>
            <dxi-column dataField="optionHTML" caption="Options" width="250" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
            <dxi-column dataField="id" caption="Id" width="80" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.lineNumber" caption="Line No" width="100" [allowEditing]="false" [hidden]="!showAsDialog"></dxi-column>
            <dxi-column dataField="note" caption="Detail Note" width="100" [allowEditing]="false" [hidden]="!showAsDialog"></dxi-column>
            <dxi-column dataField="scheduled" caption="Scheduled To Build" width="100" [allowEditing]="false" dataType="date" format="shortDate"></dxi-column>

            <!-- <dxi-column caption="Options" dataType="string" [calculateCellValue]="getHTMLOptions" [allowEditing]="false" [encodeHtml]="false" [allowSearch]="true"></dxi-column> -->
            <div *dxTemplate="let item of 'faTemplate'" class="d-flex">
                <i
                    *ngIf="item.data.orderLine.order.dealer.pastDue"
                    class="fa fa-flag ms-2"
                    style="color: darkred"
                    title="Past Due {{ item.data.orderLine.order.dealer.pastDue | date : shortDate }}"
                ></i>
                <i *ngIf="item.data.invoice?.status?.name === 'Paid'" class="fa fa-usd ms-2" style="color: #197b00" title="Paid"></i>
                <i *ngIf="item.data.invoice?.status?.name === 'Paid'" class="fa fa-usd ms-1" style="color: #197b00" title="Paid"></i>
                <i *ngIf="item.data.invoice && item.data.invoice?.status?.name === 'PartiallyPaid'" class="fa fa-usd ms-2" style="color: #197b00" title="Partially Paid"></i>
                <i *ngIf="item.data.hotOrder" class="fa fa-fire" style="color: red" title="Hot Order"></i>
                <i
                    *ngIf="dealerDeliveryConfirmationEnabled && item.data.deliveryOptionId === DeliveryOptions.TBD"
                    class="fa fa-truck ms-2"
                    style="color: red"
                    title="Delivery Option: TBD"
                ></i>
            </div>

            <div *dxTemplate="let item of 'dealerTemplate'">
                <div title="{{ canSeeDealerNotes ? item.data.orderLine.order.dealer.notes : null }}">
                    <a *ngIf="canSeeDealerNotes" [routerLink]="[]" (click)="editDealerNote(item.data.orderLine.order.dealer)">{{ item.value }}</a>
                    {{ !canSeeDealerNotes ? item.value : '' }}
                </div>
            </div>
            <div *dxTemplate="let item of 'cityTemplate'">
                <div [title]="item.data.shipAddressNotes || ''">{{ item.value }}</div>
            </div>
            <div *dxTemplate="let item of 'partNumberTemplate'">
                <div title="{{ item.data.orderLine.description }}">{{ item.data.orderLine.partNumber }}</div>
            </div>
            <div *dxTemplate="let item of 'optionTemplate'">
                <div style="font-weight: bold">{{ item.data.options }}</div>
            </div>
            <div *dxTemplate="let cell of 'editTemplate'">
                <a [routerLink]="[]" (click)="editPackingSlip(cell.data)">{{ cell.value || '' }}</a>
            </div>
            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="'/sales-orders/' + cell.data.orderLine.order.id">{{ cell.value || '(blank)' }}</a>
            </div>
            <div *dxTemplate="let cell of 'printTemplate'">
                <a [routerLink]="[]" (click)="printPDF(cell)">{{ cell.value || '' }}</a>
            </div>
            <div *dxTemplate="let cell of 'invoiceTemplate'">
                <a [routerLink]="'/invoices/' + cell.data.invoiceId">{{ cell.value }}</a>
            </div>

            <dxo-editing [mode]="'cell'" [allowUpdating]="showAsDialog"></dxo-editing>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="storageKey"></dxo-state-storing>
            <dxo-selection [mode]="mode === 'invoice' ? 'single' : 'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button [hidden]="showAsDialog" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="toggleHotOrder()" class="btn btn-sm btn-warning ms-2">
                    Hot
                </button>
                <button [hidden]="showAsDialog" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="printBuildList()" class="btn btn-sm btn-success ms-2">
                    Build List
                </button>
                <button [hidden]="showAsDialog" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="printPackList()" class="btn btn-sm btn-secondary ms-1">
                    Print Packing Slip
                </button>
                <button
                    class="btn btn-sm btn-secondary ms-1"
                    (click)="printMsrp(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Print MSRP
                </button>
                <button [hidden]="showAsDialog" [disabled]="dataGrid.instance.getSelectedRowsData().length == 0" (click)="addToPackSlip()" class="btn btn-sm btn-primary ms-2">
                    Add to Pack Slip
                </button>
                <button [hidden]="showAsDialog" [disabled]="!canRemoveFromPackSlip" (click)="removeFromPackSlip()" class="btn btn-sm btn-danger ms-2">Remove From Pack Slip</button>

                <button
                    class="btn btn-sm btn-success ms-4"
                    (click)="allocateToOrder()"
                    [hidden]="showAsDialog || !canAllocateStock"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Allocate To Order
                </button>

                <!-- <button
                    class="btn btn-sm btn-primary ms-4"
                    (click)="editOptions()"
                    [hidden]="showAsDialog"
                    [disabled]="
                        dataGrid.instance.getSelectedRowsData().length !== 1 ||
                        !dataGrid.instance.getSelectedRowsData()[0].orderLine.partId ||
                        dataGrid.instance.getSelectedRowsData()[0].orderLine.isReplacement
                    "
                >
                    Edit Options
                </button> -->
                <!-- <button
                    class="btn btn-sm btn-primary ms-4"
                    (click)="splitOrderLine()"
                    [hidden]="showAsDialog"
                    [disabled]="
                        dataGrid.instance.getSelectedRowsData().length !== 1 ||
                        !dataGrid.instance.getSelectedRowsData()[0].orderLine.partId ||
                        dataGrid.instance.getSelectedRowsData()[0].orderLine.isReplacement ||
                        dataGrid.instance.getSelectedRowsData()[0].orderLine.isMisc
                    "
                >
                    Split OrderLine
                </button> -->
                <button [hidden]="showAsDialog" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="bulkUpdate()" class="btn btn-sm btn-primary ms-1">
                    Bulk Update
                </button>
                <button
                    class="btn btn-sm btn-danger ms-3"
                    (click)="setStatusToBuilt()"
                    [hidden]="!canSetBuilt"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !canSetBuilt"
                >
                    Set Status to Built
                </button>

                <dx-drop-down-button
                    class="ms-2 print-email-dx-button"
                    text="Notes"
                    [useSelectMode]="false"
                    [items]="['Add Note', 'Add Detail Specific Note']"
                    [dropDownOptions]="{ width: 250 }"
                    [disabled]="false"
                    (onItemClick)="addNoteButtonClick($event)"
                ></dx-drop-down-button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="delete()"
                    [hidden]="!canDelete || showAsDialog"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>

                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="kickOffDetail()"
                    [hidden]="auth.currentUser.userName !== 'mreimink' && auth.currentUser.userName !== 'halferink'"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    ReKickOff
                </button>
                <button class="btn btn-sm btn-danger ms-2" (click)="markAsNotBuilt()" [hidden]="!canSetUnBuilt" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    UnBuilt
                </button>

                <button *ngIf="hasChanges()" [hidden]="showAsDialog" type="button" (click)="save()" class="btn btn-sm btn-success ms-4">Save</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderLineDetails" class="me-3"
                    ><strong
                        >{{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}</strong
                    ></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div class="modal-footer" *ngIf="showAsDialog">
        <button type="button" (click)="saveDialog()" [disabled]="processing" class="btn btn-success ms-3">Save</button>
        <button type="button" (click)="closeDialog()" class="btn btn-secondary ms-1">Close</button>
    </div>
</div>
